import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect } from 'react';
import { Spinner } from '@magento/venia-ui/lib/components/LoadingIndicator';
import defaultClasses from './searchSuggestions.module.css';
import { LocationIcon } from '../../../../../../../components';

var SearchSuggestions = function SearchSuggestions(_ref) {
  var loading = _ref.loading,
      suggestions = _ref.suggestions,
      getSuggestionItemProps = _ref.getSuggestionItemProps,
      address = _ref.address;
  var inputParts = address.split(' ').filter(function (part) {
    return part;
  });
  var regex = new RegExp("(".concat(inputParts.join('|'), ")"), 'gi');

  var getHighlightedText = function getHighlightedText(suggestion) {
    var parts = suggestion.split(regex);
    return parts.map(function (part) {
      return regex.test(part) ? React.createElement("strong", null, part) : part;
    });
  };

  return React.createElement("ul", {
    className: "".concat(defaultClasses.results, " ").concat(suggestions ? 'show' : '')
  }, loading ? React.createElement("div", {
    className: "mb-5 d-flex justify-content-center align-items-center"
  }, React.createElement(Spinner, null)) : React.createElement(React.Fragment, null, suggestions.map(function (suggestion, index) {
    return React.createElement("li", _extends({
      key: "sugg-".concat(index),
      className: defaultClasses.suggestion
    }, getSuggestionItemProps(suggestion)), React.createElement(LocationIcon, {
      color: "#828282"
    }), React.createElement("span", null, getHighlightedText(suggestion.description)));
  })));
};

export default SearchSuggestions;